import "@fontsource/lexend";
import "@fontsource/lexend/100.css";
import "@fontsource/lexend/200.css";
import "@fontsource/lexend/300.css";
import "@fontsource/lexend/400.css";
import "@fontsource/lexend/500.css";
import "@fontsource/lexend/600.css";
import "@fontsource/lexend/700.css";
import "@fontsource/lexend/800.css";
import "@fontsource/lexend/900.css";
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import useScreenSize from '../utils/screen-size'

export default function HomePage() {
    const size = useScreenSize();
    const height = `${size.width / 3}px`;
    const leftHeight = `${size.width / 12}px`;
    const rightHeight = `${size.width / 50}px`;

    useEffect(() => {
        document.title = "Marlo - Connect, Meet, Nearby";
    }, []);
    
    return (
        <diV className='home' style={{ backgroudColor: '#000' }}>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
            </Helmet>

            <div className="logo">
                <span className="logo">
                    Marlo
                </span>
                <a href='#download' className="download">Download</a>
            </div>

            <div className="title" style={{ height: height }}>
            </div>

            <div className="text" style={{ height: height }}>
            </div>

            <div id="download" className="qrcode" style={{ height: height }}>
            </div>

            <div className="leftRight">
                <div className="right" >
                    <div style={{ height: rightHeight }}></div>
                    <a href="mailto:Hello@himarlo.com">
                        <img alt='' style={{ height: size.width / 30 }} src='https://static.wixstatic.com/media/a1b568_47897ce9f2d64fe38ddd3f5d3642f587~mv2.png/v1/fill/w_48,h_48,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/a1b568_47897ce9f2d64fe38ddd3f5d3642f587~mv2.png' />
                    </a>
                    <a href="https://x.com/hi_marlo?s=21">
                        <img alt='' style={{ height: size.width / 30 }} src="https://static.wixstatic.com/media/11062b_36edc9a0843e4563836cd26e2f9e5c3a~mv2.png/v1/fill/w_48,h_48,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_36edc9a0843e4563836cd26e2f9e5c3a~mv2.png" />
                    </a>
                    <a href="https://www.instagram.com/himarlo_us?igsh=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr">
                        <img alt='' style={{ height: size.width / 30 }} src="https://static.wixstatic.com/media/11062b_cef3b719166a4815b446d4dcfcb6120d~mv2.png/v1/fill/w_48,h_48,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_cef3b719166a4815b446d4dcfcb6120d~mv2.png" />
                    </a>
                </div>
                <div className="left" style={{ height: leftHeight }}>
                </div>
            </div>

            <div className="links" style={{ fontSize: rightHeight }}>
                <Link to='/web/policy'>Privacy Policy</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Link to='/web/service'>Terms of Service</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Link to='/web/deletion'>User data deletion</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Link to='/web/admin'>Enter Backend</Link>
            </div>
        </diV>
    )
}